import { useEffect } from 'react';

var useEffectOnce = function useEffectOnce(effect) {
  useEffect(effect, []);
};

export default useEffectOnce;